/**
 * @ Author: mzc
 * @ Create Time: 2024-07-03 19:51:46
 * @ Modified by: mzc
 * @ Modified time: 2024-07-10 17:47:34
 * @ Description: 购物中心-订单列表
 */
import dayjs from "dayjs";

const initalState = {
	option: {
		time: [dayjs().format("YYYY-MM-DD 00:00:00"), dayjs().format("YYYY-MM-DD 23:59:59")],
		page: 1,
		pageSize: 20,
		systemGoodsId: null,
		payOrderNo: "",
		resellerOrderNo: "",
		cardPwd: ""
	},
};
const purchasingOrderListReducer = (state = initalState, action) => {
	switch (action.type) {
		case "PURCHASINGORDERLIST_UPDATE_OPTION":
			return { ...state, option: { ...action.payload } };
		case "PURCHASINGORDERLIST_RESET":
			return { ...JSON.parse(JSON.stringify(initalState)) };
		default:
			return state;
	}
};

export default purchasingOrderListReducer;
